import { useState, useRef } from 'react';

const useToast = () => {
  const [toastMsg, setToastMsg] = useState('');
  const timerRef = useRef(null);

  // Longer messages can pass a longer duration; 2s suits the one-liners.
  const showToast = (msg, duration = 2000) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToastMsg(msg);
    timerRef.current = setTimeout(() => setToastMsg(''), duration);
  };

  return { toastMsg, showToast };
};

export default useToast;
